import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_41: FaireProductEntity = {
  token: "legacy_prod_abbott-41",
  type: "product",
  name: 'Happiness is... Small Plate 3.5" D',
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/bc54eaa65f2c43cc14b6d963a46231c8558158868df7dd7b378bf871f135fe2b.jpeg",
  priceDollars: 10,
  subcategory: "Tableware",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
